import GetSubscriptionArticlesRequestModelBase from '../_generated/modelBases/get-subscription-articles-request-model-base';

export default class GetSubscriptionArticlesRequestModel extends GetSubscriptionArticlesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
